import type { DependencyList, EffectCallback } from 'react';
import { useEffect } from 'react';

import { useIsFirstRender } from '@/renderer/utils/hooks/useIsFirstRender';

export function useUpdateEffect(effect: EffectCallback, deps?: DependencyList) {
  const isFirst = useIsFirstRender();

  // biome-ignore lint/correctness/useExhaustiveDependencies:
  useEffect(() => {
    if (!isFirst) {
      return effect();
    }
  }, deps);
}
